import { render, staticRenderFns } from "./creditPeriodErrorList.vue?vue&type=template&id=13d06f61"
import script from "./creditPeriodErrorList.vue?vue&type=script&lang=js"
export * from "./creditPeriodErrorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports